import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { postOrderBook } from 'services/documents';
import type { TGetSecuritiesComponentsById } from '@dekafvv/sharedfrontend';

type TPostOrderBook = {
  commonDataIn: {
    procurerId: string;
    advisorNumber: string;
    wayOfOrder: string;
    custodyAccountNumber: string; // added because of the validation, not requied for Advisor
  };
  custodyAccountNumber: string;
};

export const usePostOrderBook = ({
    body,
    refetchOnMount = true,
    enabled = true,
}: {
  body: TPostOrderBook;
  refetchOnMount?: boolean;
  enabled?: boolean;
}) => {
    const query = useQuery<
    AxiosResponse<TGetSecuritiesComponentsById>,
    null | { message: string },
    TGetSecuritiesComponentsById
  >({
      queryKey: ['getSecuritiesComponentsById', body],
      queryFn: () => postOrderBook({ body }).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
      enabled,
      retry: false,
  });

    return query;
};
